// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraOutlinedSvg from "@ant-design/icons-svg/es/asn/VideoCameraOutlined";
import AntdIcon from '../components/AntdIcon';

var VideoCameraOutlined = function VideoCameraOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraOutlinedSvg
  }));
};

VideoCameraOutlined.displayName = 'VideoCameraOutlined';
export default React.forwardRef(VideoCameraOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/VideoCameraOutlined.js
// module id = 2035
// module chunks = 0